import rulesManager from '../../../base/js/managers/rules';

rulesManager.genWildText = function genWildText(config) {
  this.wildText = `<div class="rules__text">Заменяет любой символ <br>
    кроме ${this.symbols[config.scatter]} <br>
    и умножает выигрыш по линии <br>
    1 на 2, 2 на 4, 3 на 8, 4 на 16</div>`;
};

export default rulesManager;



// WEBPACK FOOTER //
// ./js/managers/rules.js